<script>
  import he from 'date-fns/locale/he';

  import { Chart } from '@client/components/charts';

  export let data = {};
  export let label = null;
  export let title = null;
  export let subtitle = null;
  export let height = '180px';
  export let width = '100%';
  export let type = 'line';
  export let unit = 'day';

  let options = {};

  const getOptions = (unit) => {
    return {
      responsive: true,
      plugins: {
        legend: false
      },
      scales: {
        x: {
          type: 'time',
          position: 'bottom',
          time: {
            parser: 'yyyy-MM-dd',
            displayFormats: {
              day: 'M/d',
              month: 'MMM'
            },
            tooltipFormat: unit === 'month' ? 'MMMM yyyy' : 'MMM d, yyyy',
            unit,
            round: unit
          },
          grid: {
            display: true
          },
          ticks: {
            maxRotation: 0,
            stepSize: unit === 'month' ? 1 : 10
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            display: true
          },
          ticks: {
            display: true,
            callback: function (value) {
              if (value % 1 === 0) {
                return value.toLocaleString();
              }
            }
          }
        }
      }
    };
  };

  $: options = getOptions(unit, type);
</script>

<Chart bind:type bind:data bind:options bind:label bind:title bind:subtitle bind:height bind:width />
